import { ExternalLink, X, Edit2 } from "lucide-react";
import { TaskLink } from "../../types";

interface LinkListProps {
  links: TaskLink[];
  onDelete?: (linkId: string) => void;
  onEdit?: (linkId: string) => void;
  className?: string;
}

export function LinkList({ links, onDelete, onEdit, className = "" }: LinkListProps) {
  if (!links || links.length === 0) return null;

  return (
    <div className={`space-y-1 ${className}`}>
      {links.map((link) => (
        <div
          key={link.id}
          className="flex items-center justify-between gap-2 p-2 bg-warm-bg-elevated rounded border border-warm-border hover:bg-warm-border-subtle group"
        >
          <a
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 flex-1 min-w-0 text-warm-blue hover:underline"
          >
            <ExternalLink size={14} className="flex-shrink-0" />
            <span className="truncate text-sm">{link.description}</span>
          </a>
          <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
            {onEdit && (
              <button
                onClick={() => onEdit(link.id)}
                aria-label={`Edit link ${link.description}`}
                className="p-1 hover:bg-warm-blue/10 rounded text-warm-blue"
              >
                <Edit2 size={14} />
              </button>
            )}
            {onDelete && (
              <button
                onClick={() => onDelete(link.id)}
                aria-label={`Delete link ${link.description}`}
                className="p-1 hover:bg-red-100 dark:hover:bg-red-900/30 rounded text-red-600 dark:text-red-400"
              >
                <X size={14} />
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
